import React, { useState } from "react";
import BodyContainer from "../components/BodyContainer";
import BottomContainer from "../components/BottomContainer";
import Footer from '../components/Footer';
import FooterLinks from "../components/FooterLinks";
import Banner from '../components/Banner';
import bannerImage from '../assets/banner4.png';
import { Helmet } from "react-helmet-async";
import '../Site.css';
import '../FAQ.css'; 

const faqs = [
  {
    question: "Who creates the courses and exams offered on PharmPrepPro?",
    answer: "All of our content—including review courses and practice exams—is developed by a team of Board Certified Pharmacotherapy Specialists (BCPS) with years of professional and instructional experience."
  },
  
  {
    question: "How do I purchase a subscription to a course or exam?",
    answer: `To purchase a subscription:
1. Log into your PharmPrepPro account (or register if you don’t already have one).
2. Navigate to the "Products" section at the top of the page(or in the hamburger menu ☰ in the top right on mobile).
3. Choose the product you’d like to purchase and click 'Add to Cart' (Note if you own any part of a bundle or already have the item subscribed or in your cart you will not be able to click the button).
4. Navigate to your cart either by using the Green Banner Link at the top of products when an item is added, Clicking the Cart 🛒 icon in the navigation bar at the top right, or open and navigate to the Cart section of the hamburger menu ☰ on mobile)"
5. Choose length for each subscription using the dropdown menu
6. Apply a discount code if available.
7. Complete payment using PayPal, credit, or debit card.`
  },
  {
    question: "Which payment methods are accepted?",
    answer: "We accept American Express, Discover, MasterCard, and Visa debit/credit cards through PayPal. Payments must be made in U.S. dollars. We do not accept cash, checks, or payments via mail or fax."
  },
  {
    question: "Do you offer shorter-term or customizable subscription packages?",
    answer: "At this time, only the subscription durations and packages displayed on our website are offered."
  },
  {
    question: "Do you provide free trials or guest access?",
    answer: "We do not offer free trials or guest accounts."
  },
  {
    question: "How do I access my subscription after purchase?",
    answer: `Subscriptions activate immediately after payment. To access your content:
1. Log into your account.
2. Click the "Study Guides" or "Practice Tests" tab to view your available products.`
  },
  {
    question: "I can’t see my purchased subscription—what should I do?",
    answer: `Confirm you’re signed in with the same Google account used at purchase. Verify that your subscription term has not lapsed. If the issue persists, please email us at pharmpreppro@gmail.com`
  },
  {
    question: "How can I reset a forgotten username or password?",
    answer: "Your Pharm Prep Pro account is linked to your Google credentials. To recover access, please use Google’s account recovery tools at https://accounts.google.com/signin/recovery."
  },
  {
    question: "Can I reset or delete my Test Result history and start over?",
    answer: "Test histories are permanent; we retain and display only your three most recent scores."
  },
  {
    question: "May I download or print subscription materials?",
    answer: "All content is accessible exclusively online. Downloading, printing, screen-capturing, or otherwise reproducing materials is prohibited."
  },
  {
    question: "What is the NAPLEX?",
    answer: "The North American Pharmacist Licensure Examination (NAPLEX) is a standardized exam developed by the NABP to assess pharmacy practice competence. It features 225 questions—200 of which count toward your score, while 25 are unscored pretest items. Many questions are case-based and require interpreting patient profiles. The NAPLEX is administered in cooperation with state boards under NABP's guidelines, with exam content created by licensed pharmacists and academic professionals."

  },
  {
    question: "How should I prepare for the NAPLEX?",
    answer: "Use study guides, practice questions, and simulation tools. Our materials help identify weak areas and simulate test-day conditions."
  },
  {
    question: "Can I obtain a refund if I’m not satisfied?",
    answer: "All sales are final. Refunds, cancellations, or subscription changes are only permitted in jurisdictions that require such policies. Please contact pharmpreppro@gmail.com for more information"
  },
  {
    question: "What is the MPJE?",
    answer: "The Multistate Pharmacy Jurisprudence Examination (MPJE) is a computer-based exam that assesses knowledge of pharmacy law at both the federal and state levels. Although based on a national framework, each jurisdiction has state-specific content."
  },
  {
    question: "How should I prepare for the MPJE?",
    answer: "Focus on mastering both federal pharmacy regulations and the specific state laws where you plan to practice. Our targeted MPJE review materials are structured to help you grasp key legal concepts and apply them in a test format."
  }
];

function FAQ() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <>
      <Helmet>
        <title>PharmPrepPro - FAQ</title>
      </Helmet>

      <BottomContainer>
        <Banner height="300px" image={bannerImage} />
        <BodyContainer>
          <h1 className="white-text">Frequently Asked Questions</h1>
          <div className="faq-container">
            {faqs.map((faq, index) => (
              <div key={index} className="faq-item">
                <button className="faq-question" onClick={() => toggleFAQ(index)}>
                  {faq.question}
                </button>
                {openIndex === index && (
                  <div className="faq-answer">
                    {faq.answer.split("\n").map((line, i) => (
                      <p key={i}>{line}</p>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </div>
        </BodyContainer>
      </BottomContainer>
      <FooterLinks />
      <Footer />
    </>
  );
}

export default FAQ;
